<template>
  <div>
    <div class="modal__vms-template-wrapper">
      <div v-if="modalData.description" class="modal__vms-description" v-html="modalData.description"></div>
        <div v-if="loading" class="vms-loading">
          <v-progress-circular
            indeterminate
            color="secondary"
            size="50"
          ></v-progress-circular>
        </div>
        <div v-else-if="staticParams.VMS_VIEW_ENABLE" class="modal__vms-content">
          <div
            v-if="vmsDetails.code && vmsDetails.mime_type"
            class="modal__vms-image-box">
            <img
              :src="`data:${vmsDetails.mime_type};base64,${vmsDetails.code}`"
              alt="vms-image"
            />
            <div class="modal__vms-datetime">{{ formatDate(vmsDetails.date_time) }}</div>
          </div>
          <div v-else class="modal__vms-image-off">
            <i class="mdi mdi-eye-off"></i>
            <div class="modal__vms-image-off-text">
              <translated-text-component translation="modal_vms_no_image_text" />
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  computed,
  defineComponent, onMounted, Ref, ref, watch,
} from 'vue';
import ModalTemplateService from '@/services/ModalTemplateService';
import store from '@/store/index';
import { IModalData } from '@/services/layers/IModalData';
import ApiService from '@/services/ApiService';
import { AxiosResponse } from 'axios';
import moment from 'moment';

const TemplateModalVmsBoard: object = defineComponent({
  props: {
    templateData: {
      type: Object,
      required: true,
    },
  },
  name: 'TemplateModalVmsBoard',
  setup(props) {
    const modalData: Ref<object> = ref({});
    const vmsDetails = ref({});
    const loading: Ref<boolean> = ref(true);
    const {staticParams} = store.state.settings;

    const getVmsBoardDetails = (id: string) => {
      return ApiService.fetchVmsBoardDetails(id)
        .then((res: AxiosResponse<any>) => res.data)
        .catch((reason) => console.error(reason));
    };

    const formatDate = (date: string) => {
      return moment.utc(date).local().format("YYYY-MM-DD HH:mm");
    };

    onMounted(() => {
      const { metaData } = props.templateData;
      modalData.value = metaData;

      getVmsBoardDetails(metaData.id)
        .then((response) => {
          console.log('VMS Board details response:', response);
          if (response && response.data && response.data.length && response.data[0].images) {
            vmsDetails.value = response.data[0].images[0];
          }
          loading.value = false;
        })
        .catch((error) => {
          console.error('Error fetching VMS Board details:', error);
          loading.value = false;
        }); 
    });

    return {
      modalData,
      vmsDetails,
      loading,
      formatDate,
      staticParams,
    };
  },
});
export default TemplateModalVmsBoard;
</script>

<style lang="scss">
.modal__vms {
  &-template-wrapper {
    text-align: center;
  }

  &-description {
    margin-bottom: rem(20px);
    font-size: rem(13px);
  }

  &-image-box {
    img {
      zoom: 2.5;
      .dark-theme & {
        border: 1px solid $yellow-static;
      }
    }
  }

  &-image-off {
    max-width: rem(320px);
    margin: 0 auto;
    background-color: $image-off-bg;
    color: $image-off-font;
    padding: rem(14px) 0;
    display: flex;
    flex-direction: column;
    align-items: center;

    i {
      font-size: rem(110px);
      line-height: 1.1;
    }

    &-text {
      font-weight: 500;
    }
  }
}

</style>
